export const ACCEPT_CONSENT = "accept";
export const REJECT_CONSENT = "reject";

const APP_CONSENT =
  process.env.NODE_ENV === "production"
    ? "priceblocs-consent"
    : "priceblocs-dev-consent";

export const isConsentAction = (consent) => consent === ACCEPT_CONSENT;

export const getConsent = () => {
  if (typeof window !== "undefined") {
    /* eslint-disable-next-line no-useless-catch */
    try {
      const consentData = window.localStorage.getItem(APP_CONSENT);
      return consentData ? JSON.parse(consentData) : null;
    } catch (err) {
      throw err;
    }
  }
};

export const setConsent = (consent = REJECT_CONSENT) => {
  if (typeof window !== "undefined") {
    /* eslint-disable-next-line no-useless-catch */
    try {
      window.localStorage.setItem(
        APP_CONSENT,
        JSON.stringify({
          hasConsent: isConsentAction(consent)
        })
      );
    } catch (err) {
      throw err;
    }
  }
};

export const postConsentActions = () => {
  if (typeof window !== "undefined") {
    window && window.fbq && window.fbq("consent", "grant");
  }
};
